import './modules/slider';
import Action from './modules/Action';
import FormValidation from './modules/FormValidation';

const $body = $('body');

// Клик
$body.on('click', '[data-click]', function () {
  const data = $(this).data('click');

  new Action(data, this);
  if ($(this).is('a')) return false;
});

new FormValidation().render();

// Сменить домен
$body.on('click', '.js-region-selector--domain', (event) => {
  const domain = $(event.currentTarget).data('domain');
  console.log(domain);
  window.location.hostname = domain;
});

$('.js-slider:not(.--active)').addClass('--active').each((slider) => {
  const $slider = $(slider);
  const data = $slider.data('slider');

  $slider.slick(data);
});
